

module.directive('americorpsSlots', function($http, ApiUrl, Notifications, BasicOptions) {
    return {
        restrict: 'E',
        scope: {
            initiative: '=',
            grantYear: '=',
            canEdit: '=',
        },
        templateUrl: 'programs/initiatives/slots',
        link: function(scope, element, attrs) {
            scope.slotTypes = BasicOptions.amcHourTypes;

            scope.showForm = function() {
                if (!scope.canEdit) return;
                scope.data = angular.copy(scope.initiative.slots);
            };

            scope.hideForm = function() {
                scope.data = null;
            };

            scope.save = function(form, data) {
                if (form.$invalid) {
                    Notifications.canned('form_errors');
                    return;
                }

                var url = ApiUrl('initiative', scope.initiative.id, 'slots');
                $http.put(url, data).then(_success, _error);
            };

            function _success(response) {
                Notifications.success('Slots updated.')
                angular.copy(response.data, scope.initiative.slots);
                scope.hideForm()
            }

            function _error(response) {
                Notifications.error('There was a problem submitting this form');
            }
        },
    };
});